import React, { useEffect, useState } from "react";
import TmsCounterService from "../../../../services/tms-counter.service";
import catchErrorFunction from "../../../../utils/tms-catch-error/tms-catch-error";
import { withRouter } from "../../../../utils/tms-with-router/tms-with-router";
import { Button, Col, notification, Popconfirm, Row, Select } from "antd";
import TmsTable from "../../../../components/tms-customs/tms-table";
import { DeleteOutlined } from "@ant-design/icons";
import { DutyServices } from "../../../../services/duty-pass.service";

const DutyPassCounters = ({ router }) => {
  const [loading, setLoading] = useState(false);
  const [counters, setCounters] = useState([]);
  const [counterId, setCounterId] = useState("");
  const [updateFlag, setUpdateFlag] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [tableCurrentPage, setTabelCurrentPage] = useState(1);
  const [tablePageSize, setTabelPageSize] = useState(15);
  const [tableTotalSize, setTabelTotalSize] = useState(0);

  useEffect(() => {
    fetchCounter();
  }, []);

  useEffect(() => {
    fetchAddedCounters();
  }, [updateFlag]);

  const clearFields = () => {
    setUpdateFlag(Math.random() * 100);
    setCounters([]);
    setCounterId("");
  };

  const fetchCounter = async () => {
    setLoading(true);
    try {
      const resp = await TmsCounterService.getAllCounter(1, 100);
      setCounters(resp?.counters);
      setLoading(false);
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setLoading(false);
    }
  };

  const fetchAddedCounters = async () => {
    setLoading(true);
    try {
      const resp = await DutyServices.getDutyPassCounters(
        tableCurrentPage,
        tablePageSize
      );
      setTableData(resp?.counters);
      setTabelTotalSize(resp?.total);
      setLoading(false);
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    let body = [
      {
        counterId: Number(counterId),
      },
    ];
    try {
      await DutyServices.createDutyCounter(body[0]);
      notification.success({
        message: "Counter Added Successful",
      });
      clearFields();
      setLoading(false);
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setLoading(false);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleTableChange = (pagination, filters, sorter) => {
    setTabelCurrentPage(pagination.current);
    setTabelPageSize(pagination.pageSize);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Counter ID",
      dataIndex: "counterId",
      key: "counterId",
      render: (text) => (
        <span>{counters.find((item) => item.id === text)?.name}</span>
      ),
    },
    {
      title: "Total Scanned",
      dataIndex: "dutyPassScanned",
      key: "dutyPassScanned",
    },
    {
      title: "Duty Passes Issued",
      dataIndex: "dutyPassIssued",
      key: "dutyPassIssued",
    },
    {
      title: "Action",
      render: (record) => {
        return (
          <Popconfirm
            title="Are you sure delete this Book?"
            onConfirm={async () => {
              setLoading(true);
              try {
                await DutyServices.deleteWalkerCounter(record?.id);
                notification.success({
                  message: "Deleted counter Successful",
                });
                setUpdateFlag(Math.random() * 100);
              } catch (error) {
                catchErrorFunction(
                  error,
                  "Token Expired, redirecting to login page in 5 seconds",
                  router
                );
              }
              setLoading(false);
            }}
            okText="Yes"
            cancelText="No"
          >
            <a>
              <DeleteOutlined />
            </a>
          </Popconfirm>
        );
      },
    },
  ];

  return (
    <div>
      <Row gutter={[20, 20]}>
        <Col span={6}>
          <label style={{ width: "100%" }}>Counter</label>
          <br />
          <Select
            style={{ width: "100%" }}
            onChange={(e) => setCounterId(e)}
            value={counterId}
          >
            {counters?.map((item) => {
              return (
                <Select.Option value={item?.id} key={item?.name}>
                  {item?.name}
                </Select.Option>
              );
            })}
          </Select>
        </Col>
        <Col>
          <label></label>
          <br />
          <Button
            type="primary"
            onClick={() => {
              handleSubmit();
            }}
            loading={loading}
          >
            Submit
          </Button>
        </Col>
      </Row>
      <br />
      <Row style={{ width: "100%" }}>
        <TmsTable
          columns={columns}
          dataSource={tableData}
          handleTableChange={handleTableChange}
          pagination={{
            total: tableTotalSize,
            current: tableCurrentPage,
            pageSize: tablePageSize,
          }}
        />
      </Row>
    </div>
  );
};

export default withRouter(DutyPassCounters);
